(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolong-game/assets/javascripts/pay/handle-subscription-pay.js') >= 0) return;  svs.modules.push('/components/numbergames/prolong-game/assets/javascripts/pay/handle-subscription-pay.js');

'use strict';

const generateSubscriptionHref = svs.numbergames.prolong_game.common.utils.generateSubscriptionHref;
const trackSubscriptionPay = svs.numbergames.prolong_game.analytics.trackSubscriptionPay;
const handleSubscriptionPay = (e, _ref) => {
  let wager = _ref.wager,
    selectedDays = _ref.selectedDays,
    trackingCategory = _ref.trackingCategory;
  e.preventDefault();
  const subscriptionHref = generateSubscriptionHref({
    productName: wager.productName,
    wagerId: wager.wagerId,
    selectedDays
  });
  trackSubscriptionPay(subscriptionHref, trackingCategory);
};
setGlobal('svs.numbergames.prolong_game.pay.handleSubscriptionPay', handleSubscriptionPay);

 })(window);